module.exports = __webpack_public_path__ + "assets/img/wcx.2821d682.png";